/*
 * @Author: Fan
 * @Date: 2020-04-19 20:11:49
 * @description:
 * @LastEditors: Fan
 */
import { DataType } from "../../../../form/typings";
import i18n from "../../../i18n";
import { inputControlOptions, NumberFormatType, } from "../../../../form/component-schema";
export default {
    $id: "number",
    type: DataType.Object,
    $ref: inputControlOptions.$id,
    properties: {
        widgetType: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        defaultValue: {
            type: DataType.String,
            title: i18n.t('dataitem.DefaultValue').toString(),
            default: "",
        },
        placeholder: {
            type: DataType.String,
            title: i18n.t('dataitem.Placeholder').toString(),
            default: i18n.t('dataitem.InputPlaceholder').toString(),
        },
        format1: {
            type: DataType.String,
            title: i18n.t('dataitem.Format1').toString(),
        },
        format: {
            type: DataType.String,
            title: i18n.t('dataitem.Format').toString(),
            default: NumberFormatType.Int,
        },
        syncFormate: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.SyncDefaultFormat').toString(),
            default: true,
        },
        shortTextStitch: {
            type: DataType.String,
            title: i18n.t('dataitem.CalculationRules').toString(),
        },
        verifyFormula: {
            type: DataType.String,
            title: i18n.t('dataitem.SubmitValidation').toString(),
        },
        dataLinkage: {
            type: DataType.String,
            title: i18n.t('dataitem.DataLinkage').toString(),
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
        readonlyCondition: {
            type: DataType.String,
            title: i18n.t('dataitem.ReadonlyConditions').toString(),
        },
    },
};
